import * as PropTypes from "prop-types";
import {connect} from 'react-redux'
import {ScrollableCard, utils, PageContent} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
import {Link} from "react-router-dom";
import * as uzivatelActions from "../../actions/uzivatelActions";
import * as opravneniActions from "../../actions/opravneniActions";
import * as localStorageUtils from "../../utils/localStorageUtils";
import {SPOLECNOST_ID_KEY} from "../../const/const";
import Title from "../../components/Title";
import './CustomerPage.scss';

/**
 * Wrapper pro stránky zákazníka pro jednodušší budoucí přestylování.
 * Mimo jiné zobrazuje barevný horní pruh.
 */
class CustomerPage extends Component {

    static propTypes = {
        title: PropTypes.string.isRequired, // název stránky v záhlaví, např. Úvodní obrazovka
        subtitle: PropTypes.string, // název podstránky v záhlaví, např. Nová objednávka
        children: PropTypes.node, // samotný obsah stránky
    };

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate() {
        this.fetchData();
    }

    fetchData = () => {
        const {loggedInUser, spolecnostId, spolecnostiUzivatelList} = this.props;
        this.props.dispatch(opravneniActions.fetchLoggedInUserIfNeeded());
        if (loggedInUser.fetched && !loggedInUser.isFetching) {
            this.props.dispatch(uzivatelActions.fetchSpolecnostIdIfNeeded(loggedInUser.data.id));
            // v případě že přihlášený zákazník nemá zvolenou žádnou aktivní společnost, nastavíme mu automaticky první jemu přiřazenou, pokud taková existuje
            if (spolecnostId.fetched && !spolecnostId.isFetching && !spolecnostId.data) {
                uzivatelActions.fetchSpolecnostiPrihlasenyUzivatelIfNeeded(loggedInUser);
                if (spolecnostiUzivatelList.fetched && !spolecnostiUzivatelList.isFetching) {
                    if (spolecnostiUzivatelList.rows.length > 0) {
                        localStorageUtils.save(loggedInUser.data.id, SPOLECNOST_ID_KEY, spolecnostiUzivatelList.rows[0].id);
                        uzivatelActions.invalidateSpolecnostId(loggedInUser.data.id);
                    }
                }
            }
        }
    };

    render() {
        const {title, subtitle, children} = this.props;
        let headerContent;
        if (subtitle) {
            headerContent = <div>
                <Link to="/"><span>{title}</span></Link> > <span className="active">{subtitle}</span>
            </div>;
        } else {
            headerContent = <div>
                <span className="active">{title}</span>
            </div>;
        }
        return <Title title={title}>
            <div className="w-100 h-100 customer-page">
                <div className="page-content-header">
                    {headerContent}
                </div>
                <PageContent fullWidth>
                    <ScrollableCard>
                        {children}
                    </ScrollableCard>
                </PageContent>
            </div>
        </Title>
    }
}

function mapStateToProps(state) {
    return {
        loggedInUser: utils.storeFromArea(state, opravneniActions.LOGGED_IN_USER_AREA),
        spolecnostId: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOST_ID_DETAIL_AREA),
        spolecnostiUzivatelList: utils.storeFromArea(state, uzivatelActions.PRIHLASENY_UZIVATEL_SPOLECNOSTI_LIST_AREA),
    }
}

export default connect(mapStateToProps)(CustomerPage);

